import { useState } from 'react'

import { removeAccount } from '../savedAccounts'
import styles from './AccountPicker.module.scss'

const AccountPicker = ({
  accounts,
  onSelectAccount,
  onUseAnotherAccount,
  onAccountsChange
}) => {
  const [removingEmail, setRemovingEmail] = useState(null)

  const handleRemoveAccount = (e, email) => {
    e.stopPropagation()
    setRemovingEmail(email)

    setTimeout(() => {
      removeAccount(email)
      onAccountsChange()
      setRemovingEmail(null)
    }, 200)
  }

  return (
    <div>
      <div className="login-content">
        <div className="swpm-login-phone__container">
          <div className="swpm-login-phone__info">
            <h1>Welcome back</h1>
            <p>Select an account to login</p>
          </div>
        </div>
        <div className="swpm-login-phone__phone">
          <div className={styles.accountList}>
            {accounts.map(account => (
              <button
                key={account.email}
                className={`${styles.accountItem} ${
                  removingEmail === account.email ? styles.removing : ''
                }`}
                onClick={() => onSelectAccount(account.email)}
                disabled={removingEmail === account.email}
              >
                <div className={styles.accountInfo}>
                  <span className={styles.accountName}>{account.name}</span>
                  <span className={styles.accountEmail}>{account.email}</span>
                </div>
                <button
                  className={styles.removeButton}
                  onClick={e => handleRemoveAccount(e, account.email)}
                  aria-label={`Remove ${account.email}`}
                >
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M12 4L4 12M4 4L12 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </button>
            ))}
          </div>
        </div>
        <button className={styles.anotherAccountButton} onClick={onUseAnotherAccount}>
          Login with another account
        </button>
      </div>
    </div>
  )
}

export default AccountPicker
